import dotenv from "dotenv";
import { z } from "zod";

dotenv.config();

const envSchema = z.object({
  NODE_ENV: z.enum(["development", "production"]).default("development"),
  PORT: z.number().default(5000),
  DATABASE_URL: z.string(),
  REDIS_URL: z.string(),
  JWT_SECRET: z.string(),
  ACCESS_TOKEN_EXPIRE_IN: z.string().default("15m"),
  REFRESH_TOKEN_EXPIRE_IN: z.string().default("30d"),
  WHATSAPP_ACCESS_TOKEN: z.string(),
  WHATSAPP_PHONE_NUMBER: z.string(),
  WHATSAPP_API_URL: z.string(),
});

export const env = envSchema.parse(process.env);
